/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountWelcomeTileViewProps } from '@msdyn365-commerce-modules/account-management';

const AccountWelcomeTileView: React.FC<IAccountWelcomeTileViewProps> = props => {
    const {
        AccountWelcomeTile,
        config,
        data: {
            accountInformation: { result: customer }
        },
        context
    } = props;

    const firstName = customer?.FirstName || '';
    const middleName = customer?.MiddleName || '';
    const lastName = customer?.LastName || '';
    const accountNumber = customer?.AccountNumber || '';

    const fullName = [firstName, middleName, lastName].filter(Boolean).join(' ');
    const name = fullName || customer?.Name || '';

    const heading = {
        ...config.heading,
        ...{
            text: `${config.heading.text ? config.heading.text : ''} ${customer ? name : ''}`
        }
    };

    const handleHeadingChange = (event: Msdyn365.ContentEditableEvent) => {
        config.heading.text = event.target.value;
    };

    return (
        <Module {...AccountWelcomeTile}>
            <Msdyn365.Text
                className='ms-account-welcome-tile__heading'
                tag={heading.tag}
                text={heading.text}
                editProps={{ onEdit: handleHeadingChange, requestContext: context.request }}
            />
            {accountNumber && <span className='ms-account-welcome-tile__heading'> - {accountNumber}</span>}
        </Module>
    );
};

export default AccountWelcomeTileView;
